import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const authApi = {
  login: (username, password) => axiosClient.post(ENDPOINTS.auth.login, { username, password }).then(unwrap),
};
